import Cookies from 'js-cookie';

const api = () => process.env.REACT_APP_BACKEND_ADDRESS;

export const savePreference = async (key, value) => {
    localStorage.setItem(key, value);
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user?.id) return;
    try {
        const res = await fetch(`${api()}/users/${user.id}/preferences`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${Cookies.get('token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ preferences: { [key]: value } }),
        });
        if (res.ok) {
            const updated = await res.json();
            const newUser = { ...user, preferences: updated.preferences };
            localStorage.setItem('user', JSON.stringify(newUser));
        }
    } catch {
        // localStorage already updated — silently fail the remote sync
    }
};

export const applyStoredPreferences = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const prefs = user?.preferences || {};
    if (prefs.darkMode !== undefined) localStorage.setItem('darkMode', prefs.darkMode);
    if (prefs.showAllRecipes !== undefined) localStorage.setItem('showAllRecipes', prefs.showAllRecipes);
};
